"use client";

import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["transition", "beforeEnter", "afterEnter", "beforeLeave", "afterLeave", "enter", "enterFrom", "enterTo", "entered", "leave", "leaveFrom", "leaveTo"],
  _excluded2 = ["show", "appear", "unmount"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import c, { Fragment as k, createContext as ne, useContext as q, useEffect as ge, useMemo as ie, useRef as b, useState as O } from "react";
import { useDisposables as ve } from '../../hooks/use-disposables.js';
import { useEvent as E } from '../../hooks/use-event.js';
import { useIsMounted as be } from '../../hooks/use-is-mounted.js';
import { useIsoMorphicEffect as D } from '../../hooks/use-iso-morphic-effect.js';
import { useLatestValue as Ee } from '../../hooks/use-latest-value.js';
import { useServerHandoffComplete as re } from '../../hooks/use-server-handoff-complete.js';
import { useSyncRefs as oe } from '../../hooks/use-sync-refs.js';
import { transitionDataAttributes as Se, useTransition as Re } from '../../hooks/use-transition.js';
import { OpenClosedProvider as ye, State as x, useOpenClosed as se } from '../../internal/open-closed.js';
import { classNames as Pe } from '../../utils/class-names.js';
import { match as le } from '../../utils/match.js';
import { RenderFeatures as xe, RenderStrategy as P, compact as Ne, forwardRefWithAs as J, isFragment as _e, useRender as ae } from '../../utils/render.js';
function ue(e) {
  var t;
  return !!(e.enter || e.enterFrom || e.enterTo || e.leave || e.leaveFrom || e.leaveTo) || !_e((t = e.as) != null ? t : de) || c.Children.count(e.children) === 1;
}
let V = ne(null);
V.displayName = "TransitionContext";
var De = (n => (n.Visible = "visible", n.Hidden = "hidden", n))(De || {});
function He() {
  let e = q(V);
  if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}
function Ae() {
  let e = q(w);
  if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}
let w = ne(null);
w.displayName = "NestingContext";
function M(e) {
  return "children" in e ? M(e.children) : e.current.filter(_ref => {
    let {
      el: t
    } = _ref;
    return t.current !== null;
  }).filter(_ref2 => {
    let {
      state: t
    } = _ref2;
    return t === "visible";
  }).length > 0;
}
function Te(e, t) {
  let n = Ee(e),
    l = b([]),
    S = be(),
    R = ve(),
    d = E(function (o) {
      let i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : P.Hidden;
      let a = l.current.findIndex(_ref3 => {
        let {
          el: s
        } = _ref3;
        return s === o;
      });
      a !== -1 && (le(i, {
        [P.Unmount]() {
          l.current.splice(a, 1);
        },
        [P.Hidden]() {
          l.current[a].state = "hidden";
        }
      }), R.microTask(() => {
        var s;
        !M(l) && S.current && ((s = n.current) == null || s.call(n));
      }));
    }),
    y = E(o => {
      let i = l.current.find(_ref4 => {
        let {
          el: a
        } = _ref4;
        return a === o;
      });
      return i ? i.state !== "visible" && (i.state = "visible") : l.current.push({
        el: o,
        state: "visible"
      }), () => d(o, P.Unmount);
    }),
    C = b([]),
    p = b(Promise.resolve()),
    h = b({
      enter: [],
      leave: []
    }),
    g = E((o, i, a) => {
      C.current.splice(0), t && (t.chains.current[i] = t.chains.current[i].filter(_ref5 => {
        let [s] = _ref5;
        return s !== o;
      })), t == null || t.chains.current[i].push([o, new Promise(s => {
        C.current.push(s);
      })]), t == null || t.chains.current[i].push([o, new Promise(s => {
        Promise.all(h.current[i].map(_ref6 => {
          let [r, f] = _ref6;
          return f;
        })).then(() => s());
      })]), i === "enter" ? p.current = p.current.then(() => t == null ? void 0 : t.wait.current).then(() => a(i)) : a(i);
    }),
    v = E((o, i, a) => {
      Promise.all(h.current[i].splice(0).map(_ref7 => {
        let [s, r] = _ref7;
        return r;
      })).then(() => {
        var s;
        (s = C.current.shift()) == null || s();
      }).then(() => a(i));
    });
  return ie(() => ({
    children: l,
    register: y,
    unregister: d,
    onStart: g,
    onStop: v,
    wait: p,
    chains: h
  }), [y, d, l, g, v, h, p]);
}
let de = k,
  fe = xe.RenderStrategy;
function Fe(e, t) {
  var ee, te;
  let {
      transition: n = !0,
      beforeEnter: l,
      afterEnter: S,
      beforeLeave: R,
      afterLeave: d,
      enter: y,
      enterFrom: C,
      enterTo: p,
      entered: h,
      leave: g,
      leaveFrom: v,
      leaveTo: o
    } = e,
    i = _objectWithoutProperties(e, _excluded),
    [a, s] = O(null),
    r = b(null),
    f = ue(e),
    U = oe(...(f ? [r, t, s] : t === null ? [] : [t])),
    H = (ee = i.unmount) == null || ee ? P.Unmount : P.Hidden,
    {
      show: u,
      appear: z,
      initial: K
    } = He(),
    [m, j] = O(u ? "visible" : "hidden"),
    Q = Ae(),
    {
      register: A,
      unregister: F
    } = Q;
  D(() => A(r), [A, r]), D(() => {
    if (H === P.Hidden && r.current) {
      if (u && m !== "visible") {
        j("visible");
        return;
      }
      return le(m, {
        ["hidden"]: () => F(r),
        ["visible"]: () => A(r)
      });
    }
  }, [m, r, A, F, u, H]);
  let G = re();
  D(() => {
    if (f && G && m === "visible" && r.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [r, m, G, f]);
  let ce = K && !z,
    Y = z && u && K,
    B = b(!1),
    I = Te(() => {
      B.current || (j("hidden"), F(r));
    }, Q),
    Z = E(W => {
      B.current = !0;
      let L = W ? "enter" : "leave";
      I.onStart(r, L, _ => {
        _ === "enter" ? l == null || l() : _ === "leave" && (R == null || R());
      });
    }),
    $ = E(W => {
      let L = W ? "enter" : "leave";
      B.current = !1, I.onStop(r, L, _ => {
        _ === "enter" ? S == null || S() : _ === "leave" && (d == null || d());
      }), L === "leave" && !M(I) && (j("hidden"), F(r));
    });
  ge(() => {
    f && n || (Z(u), $(u));
  }, [u, f, n]);
  let pe = (() => !(!n || !f || !G || ce))(),
    [, T] = Re(pe, a, u, {
      start: Z,
      end: $
    }),
    Ce = Ne(_objectSpread({
      ref: U,
      className: ((te = Pe(i.className, Y && y, Y && C, T.enter && y, T.enter && T.closed && C, T.enter && !T.closed && p, T.leave && g, T.leave && !T.closed && v, T.leave && T.closed && o, !T.transition && u && h)) == null ? void 0 : te.trim()) || void 0
    }, Se(T))),
    N = 0;
  m === "visible" && (N |= x.Open), m === "hidden" && (N |= x.Closed), u && m === "hidden" && (N |= x.Opening), !u && m === "visible" && (N |= x.Closing);
  let he = ae();
  return c.createElement(w.Provider, {
    value: I
  }, c.createElement(ye, {
    value: N
  }, he({
    ourProps: Ce,
    theirProps: i,
    defaultTag: de,
    features: fe,
    visible: m === "visible",
    name: "Transition.Child"
  })));
}
function Ie(e, t) {
  let {
      show: n,
      appear: l = !1,
      unmount: S = !0
    } = e,
    R = _objectWithoutProperties(e, _excluded2),
    d = b(null),
    y = ue(e),
    C = oe(...(y ? [d, t] : t === null ? [] : [t]));
  re();
  let p = se();
  if (n === void 0 && p !== null && (n = (p & x.Open) === x.Open), n === void 0) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
  let [h, g] = O(n ? "visible" : "hidden"),
    v = Te(() => {
      n || g("hidden");
    }),
    [o, i] = O(!0),
    a = b([n]);
  D(() => {
    o !== !1 && a.current[a.current.length - 1] !== n && (a.current.push(n), i(!1));
  }, [a, n]);
  let s = ie(() => ({
    show: n,
    appear: l,
    initial: o
  }), [n, l, o]);
  D(() => {
    n ? g("visible") : !M(v) && d.current !== null && g("hidden");
  }, [n, v]);
  let r = {
      unmount: S
    },
    f = E(() => {
      var u;
      o && i(!1), (u = e.beforeEnter) == null || u.call(e);
    }),
    U = E(() => {
      var u;
      o && i(!1), (u = e.beforeLeave) == null || u.call(e);
    }),
    H = ae();
  return c.createElement(w.Provider, {
    value: v
  }, c.createElement(V.Provider, {
    value: s
  }, H({
    ourProps: _objectSpread(_objectSpread({}, r), {}, {
      as: k,
      children: c.createElement(me, _objectSpread(_objectSpread(_objectSpread({
        ref: C
      }, r), R), {}, {
        beforeEnter: f,
        beforeLeave: U
      }))
    }),
    theirProps: {},
    defaultTag: k,
    features: fe,
    visible: h === "visible",
    name: "Transition"
  })));
}
function Le(e, t) {
  let n = q(V) !== null,
    l = se() !== null;
  return c.createElement(c.Fragment, null, !n && l ? c.createElement(X, _objectSpread({
    ref: t
  }, e)) : c.createElement(me, _objectSpread({
    ref: t
  }, e)));
}
let X = J(Ie),
  me = J(Fe),
  Oe = J(Le),
  Ke = Object.assign(X, {
    Child: Oe,
    Root: X
  });
export { Ke as Transition, Oe as TransitionChild };